import React, { Component } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import Home from './components/home';
import QuestionPage from './components/question-page';
import ResultPage from './components/result-page';
import Logo from './logo.svg';
import { CSSTransitionGroup } from 'react-transition-group'

const styleInner = {
  margin: "auto",
};

class App extends Component {
  componentDidMount() {

  }
  render()
  {
    return (
      <Router>
        <Route render={({ location }) => (
          <div className="flex vh-100 vw-100 sans-serif flex-column items-center overflow-y-scroll">
            <div className="sans-serif self-start-ns mt3 ml3 dark-blue-gray fw9 tracked-tight lh-tight">
              <h1 className="mv0 fw9 f3-ns f5">SaaS <span className="gecko-green">Metrics</span> <br /> Generator</h1>
            </div>

            <div style={styleInner}>
              <Route exact path="/" component={Home}/>
                <CSSTransitionGroup
                  transitionName="fade"
                  transitionEnterTimeout={300}
                  transitionLeave={false}
                >
                  <Route location={location} key={location.key}>
                    <div>
                      <Route
                        path="/questions"
                        component={QuestionPage}/>

                      <Route path="/results" component={ResultPage}/>
                    </div>
                  </Route>
                </CSSTransitionGroup>
            </div>

            <a href="https://www.geckoboard.com/" target="_blank" rel="noreferrer noopener" className="db sans-serif f6-ns f7 self-start ml3">
              <img src={Logo} className="fl" alt="Geckoboard" />
              <div className="fl ml3">
              <p className="mt0 mb1 dark-blue-gray fw7">Powered by Geckoboard</p>
              <p className="mt0 light-blue-gray">Live TV dashboard software for businesses</p>
              </div>
            </a>
          </div>
        )}/>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js